import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomModulesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CustomModules",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.97 2.93c-.44.33-.51.65-.29 1.64s.66 4.95 3.18 6.35c2.53 1.41 6.1-2.09 4.53-4.57S6.03 4.69 5.17 3.87s-1.3-1.51-2.2-.95ZM13.38 9.51l.06.06c.37.37.37.96 0 1.33l-2.85 2.85c-.37.37-.96.37-1.33 0l-.06-.06a.936.936 0 0 1 0-1.33l2.85-2.85c.37-.37.97-.37 1.33 0M29.23 25.32l-9.59-9.58 4.04-4.04c.29.06.63.09.97.09 2.71 0 4.9-2.2 4.9-4.91v-.02c0-.62-.12-1.21-.31-1.75l-2.36 2.31c-.32.32-.77.54-1.28.54s-.95-.21-1.28-.54c-.38-.38-.63-.92-.63-1.52s.24-1.13.63-1.52l2.1-2.03c-.53-.21-1.13-.32-1.78-.32a4.912 4.912 0 0 0-4.82 5.86v-.03l-4.05 4.04-.58-.58-3.79 3.96.51.5-9.11 9.08c-.5.51-.8 1.18-.8 1.93 0 1.51 1.23 2.73 2.73 2.73.75 0 1.44-.3 1.93-.81l9.09-9.1 9.59 9.57c.5.5 1.18.8 1.93.8 1.51 0 2.73-1.23 2.73-2.73a2.63 2.63 0 0 0-.77-1.93M4.3 27.96a.696.696 0 1 1 0-1.39c.39 0 .7.3.7.69s-.31.7-.7.7"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M18.36 30h-6.55c-1.55 0-2.82-1.26-2.82-2.82v-6.55c0-.75.29-1.46.83-1.99l8.82-8.82c1.06-1.07 2.92-1.06 3.98 0l6.55 6.55c.53.53.83 1.24.83 1.99s-.29 1.46-.83 1.99l-8.82 8.82c-.53.53-1.24.83-1.99.83m2.28-19c-.22 0-.42.08-.58.24l-8.82 8.82c-.15.15-.24.36-.24.58v6.55c0 .45.37.82.82.82h6.55c.22 0 .42-.08.58-.24l8.82-8.82c.15-.15.24-.36.24-.58s-.08-.42-.24-.58l-6.55-6.55a.83.83 0 0 0-.58-.24"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26.08 23.04c-.26 0-.51-.1-.71-.29l-9.12-9.12a.996.996 0 1 1 1.41-1.41l9.12 9.12a.996.996 0 0 1-.71 1.7ZM27 30h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1-.45 1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 1.65-1.35 3-3 3M6 30H5c-1.65 0-3-1.35-3-3v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55.45 1 1 1h1c.55 0 1 .45 1 1s-.45 1-1 1M29 7c-.55 0-1-.45-1-1V5c0-.55-.45-1-1-1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c1.65 0 3 1.35 3 3v1c0 .55-.45 1-1 1M3 7c-.55 0-1-.45-1-1V5c0-1.65 1.35-3 3-3h1c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1 .45-1 1v1c0 .55-.45 1-1 1M3 23c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1M3 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1M29 13c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M22 4h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M14 4h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
      })]
    })
  }));
};